import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Dialog, IconButton, Typography, Box } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslate } from 'react-admin';
import { getFullTime } from '../utils';
import { baseAuthUrl } from '../authProvider';
import AttachmentItem from '../message/table-attachment-item';
import CloseButton from '../CustomizedUIs/CloseButton';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    title: {
        color: '#227fc2'
    }
});

const useStyles = makeStyles(theme => ({
    title: {
        color: '#227fc2'
    },
}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <CloseButton onClick={onClose} />
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

function Item({ message }) {
    // const [categories, setCategories] = useState([]);
    const classes = useStyles();
    const translate = useTranslate()
    if (message === undefined) return null;
    const { fromUser, toUser, createdAt, subject, categories } = message;
    const handleDownload = id => {
        window.open(`${baseAuthUrl}/category/download/${id}`);
    }

    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                    <Typography variant='h6' className={classes.title}>{translate('resources.messages.from')}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography>{message.owner.firstName + " " + message.owner.lastName}</Typography>
                </Grid>
            </Grid >
            <Grid container spacing={3}>
                <Grid item xs={1}>
                    <Typography variant='h6' className={classes.title}>{translate('resources.messages.sent')}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography>{getFullTime(createdAt)}</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                    <Typography variant='h6' className={classes.title}>{translate('resources.messages.to')}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography>{message.toOwners}</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                    <Typography variant='h6' className={classes.title}>{translate('resources.messages.subject')}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography>{message.message.subject}</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                    <Typography variant='h6' className={classes.title}>{translate('resources.messages.Message')}</Typography>
                </Grid>
                <Grid item xs={11}>
                    <Typography variant="body1" style={{ fontFamily: message.message.dyslexie ? 'Dyslexie' : 'UniviaPro-Book', whiteSpace: 'pre-wrap' }}>{message.message.message}</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box style={{ maxHeight: "60vh", overflow: 'auto' }}>
                        {
                            categories.map(item =>
                                item.category !== null &&
                                <AttachmentItem
                                    remaneCategory={() => { }}
                                    item={item.category}
                                    key={item.id + ''}
                                    onDeleteOne={() => { }}
                                    handleDownload={handleDownload}
                                    isDownload={true}
                                    hiddenReload={true}
                                />
                            )
                        }
                    </Box>
                </Grid>
            </Grid>
            <hr />
        </Fragment>
    )
}

function Index({ onClose, onReply, title, messages, open, isCreate }) {
    const translate = useTranslate();
    if (messages === undefined) return null;
    return (
        <div>
            <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open} maxWidth='md' fullWidth>
                <DialogTitle id="customized-dialog-title" >
                    {title}
                    {isCreate &&
                        <Button style={{ float: 'right' }} variant="contained" color="primary" onClick={() => onReply(JSON.parse(messages.message.ids), messages)}>
                            {translate('pos.messages.reply')}
                        </Button>
                    }
                </DialogTitle>
                <DialogContent dividers>
                    <Item message={messages} />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onClose} color="primary">
                        {translate('pos.common.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

Index.propTypes = {
    onClose: PropTypes.func.isRequired,
    onReply: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    messages: PropTypes.array,
}

export default Index;
